<template>
  <b-card
    v-b-modal.modal
    :img-src="imageProp"
    img-alt="The best app to monitor your open source project"
    img-top
    class="text-center"
    align="center"
    no-body
  >
    <template v-slot:header>
      <p class="project-title">
        <strong>{{ projectTitleProp }}</strong>
      </p>
    </template>
    <template v-slot:footer>
      <b-button v-b-modal="modalId" style="background-color: #1a1a1a; border-radius: 15px;">See more</b-button>
      <!-- The modal which appears when we click on "see more" -->
      <b-modal size="lg" :id="modalId" scrollable hide-footer>
        <template v-slot:modal-title>
          <!-- Modal title -->
          <p class="project-title">
            <strong>{{ projectTitleProp }}</strong>
          </p>
        </template>
        <!-- Description -->
        <div class="d-block" style="color: #1a1a1a !important;">
          <b-row>
            <b-carousel
              id="carousel-1"
              v-model="slide"
              :interval="14000"
              controls
              fade
              indicators
              img-height="910px"
              img-width="1918px"
              background="#ababab"
            >
              <b-carousel-slide
                :style="picStyle"
                v-for="(pic, index) in picturesProp"
                :key="index"
                :img-src="pic"
              ></b-carousel-slide>
            </b-carousel>
          </b-row>
          <!-- Description -->
          <b-row style="margin: auto; color: #1a1a1a !important;" v-html="descriptionProp" />
          <b-row>
            <b-button
              v-show="urlProp"
              v-b-modal="modalId"
              style="background-color: #1a1a1a; border-radius: 15px; margin: auto "
              @click="gotToUrl"
            >Checkout the source code</b-button>
          </b-row>
        </div>
      </b-modal>
    </template>
  </b-card>
</template>
<script>
import marked from "marked";
export default {
  props: [
    "projectTitle",
    "image",
    "id",
    "pictures",
    "description",
    "picPadding",
    "url",
  ],
  data: function () {
    return {
      projectTitleProp: this.projectTitle,
      urlProp: this.url,
      imageProp: this.image ? this.image : "/img/defaultProject.png",
      idProp: this.id,
      picturesProp: this.pictures,
      descriptionProp: marked(this.description, { sanitize: true }),
      modalId: "modal-center-" + this.id,
      sliding: true,
      slide: 0,
      picStyle: {
        Padding: this.picPadding,
      },
    };
  },
  methods: {
    gotToUrl() {
      // Open the url in anorther tab
      window.open(this.urlProp, "_blank");
    },
    toggleAutoSwap() {
      this.sliding = true;
    },
    unToggleAutoSwap() {
      this.sliding = false;
    },
  },
};
</script>
<style scoped>
p {
  color: aqua;
}
.card {
  max-width: 200px;
  min-width: 200px;
  margin: auto;
  margin-top: 20px;
  box-shadow: 0 0px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
  /* margin: auto !important;
        margin-top: 10px !important;
        margin-bottom: 10px !important; */
}
.card-img-top,
.card {
  border-radius: 15px;
}
.project-title {
  color: #1a1a1a;
}
.card-img-top {
  max-height: 150px;
  margin: auto;
}
</style>